import { render } from "./Create.vue?vue&type=template&id=6916f93a"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Assessments/Create.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6916f93a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6916f93a', __exports__)) {
    console.log('reload')
    api.reload('6916f93a', __exports__)
  }
  
  module.hot.accept("./Create.vue?vue&type=template&id=6916f93a", () => {
    console.log('re-render')
    api.rerender('6916f93a', render)
  })

}


export default __exports__